import type { JSX, Ref } from 'react'

import React from 'react'
import { Background, Color } from './ToggleSwitch.h'
import { Label, Slider } from './ToggleSwitch.styled'

export interface IToggleSwitchProps {
  ref?: Ref<HTMLLabelElement>
  id?: string
  name?: string
  background?: Background
  backgroundHovered?: Background
  color?: Color
  colorDisabled?: Color
  backgroundChecked?: Background
  backgroundCheckedDisabled?: Background
  backgroundDisabled?: Background
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (isChecked: boolean) => void
  disabled?: boolean
  className?: string
}

export function ToggleSwitch({
  ref,
  id,
  name = 'radio',
  background = Background.SURFACE_DARK_6,
  color = Color.TEXT_ICON_PRIMARY,
  colorDisabled = Color.SURFACE_OPACITY_LIGHT_20,
  backgroundChecked = Background.ACCENT_PRIMARY_GRADIENT,
  backgroundCheckedDisabled = Background.SURFACE_DARK_6,
  backgroundDisabled = Background.SURFACE_DARK_6,
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  className = '',
}: IToggleSwitchProps): JSX.Element {
  const onChangeHandler = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked)
    },
    [onChange]
  )

  return (
    <Label
      ref={ref}
      htmlFor={id}
      className={className}
      backgroundChecked={backgroundChecked}
      backgroundCheckedDisabled={backgroundCheckedDisabled}
      backgroundDisabled={backgroundDisabled}
      colorDisabled={colorDisabled}
    >
      <input
        type='checkbox'
        id={id}
        name={name}
        checked={checked}
        onChange={onChangeHandler}
        defaultChecked={defaultChecked}
        disabled={disabled}
      />
      <Slider background={background} colorDefault={color} />
    </Label>
  )
}
